import "../assets/css/package.css"
import { useEffect, useRef, useState } from "react"
import CourseInfoWidget from "../components/widgets/CourseInfoWidget"
import SocialShareWidget from "../components/widgets/SocialShareWidget"
import { Alert, Button, Input } from "@mui/material"
import Payment from "./Payment"
import { getUserNameByGId } from "../handler/LoginAndSingupHandler"
import { addBeneficiary, actionBeneficiary } from "../handler/accountHandler"
import packagePoster from "../Common/PackagePoster.js";
import UserLoader from "src/Dashboard/UserLoader"
import confetti from 'canvas-confetti';
import UserLoaderBlankBackground from "src/Dashboard/UserLoaderBlankBackground"
import axios from "axios"
import { GetCourseList } from "src/handler/coursehandler"
import courseImage from "src/Common/CourseImage"
import { ClipLoader, MoonLoader } from "react-spinners"
import CartIcon from "../Payment/CartIcon";
import CartModal from "./CartModal"

const Package = () => {
    var discountOnPackage = 20;
    var discountOnCourses = 10;
    const [loader, setLoader] = useState(false);
    const [template, setTemplate] = useState("package");
    const [sponsorGrowniverseId, SetSponsorGrowniverseId] = useState("");
    const [addNewSponsorGrowniverseId, SetAddNewSponsorGrowniverseId] = useState("");
    const [couponCode, setCouponCode] = useState(false);
    const [inputCouponCode, setInputCouponCode] = useState("");
    const [showCouponCode, setShowCouponCode] = useState(false);
    const [userInformationId, setUserInformationId] = useState("");
    const [invalidCouponCode, setInvalidCouponCode] = useState(false);
    const [getShowPackages, setShowPackages] = useState(false);
    const [packages, setPackages] = useState([
        {
            "packageId": 0,
            "packageName": "",
            "packageDescription": "",
            "packagePrice": 12000,
            "discountedPrice": 8500,
        }
    ]);
    const [packageDetailData, setPackageDetailPage] = useState({
        "packageId": 0,
        "packageName": "",
        "packageDescription": "Coming Soon",
        "packagePrice": 12000,
        "discountedPrice": 8500
    })
    const runOnce = useRef(false);

    const packageDetails = (pack: any) => {
        
        if (pack) {
            setTemplate("packageDetail")
            setPackageDetailPage(pack);
            window.scrollTo(0, 0);
        }
    };

    useEffect(() => {
        if (runOnce.current === false) {
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            if (userProfile.status > 3) {
                window.location.href = "/dashboard";
            }
            setUserInformationId(userProfile.userInformationId);
            SetSponsorGrowniverseId(userProfile.sponsorGrowniverseId);
            var storedPackages = localStorage.getItem("packages");
            var packagesData = JSON.parse(storedPackages ?? "");
            setPackages(packagesData);
            runOnce.current = true;
        }
    }, [runOnce])
    const DateTimeDisplay = (isoString: string) => {
        const date = new Date(isoString);

        // Add one day to the date correctly
        date.setDate(date.getDate() + 1);

        // Get the day, month name, and year
        const day = date.getDate(); // Automatically adjusts for the new day
        const monthName = date.toLocaleString("en-US", { month: "long" }); // Get full month name
        const year = date.getFullYear();
        // Combine date and time
        var formattedDateTime = `${day} ${monthName} ${year}`;
        return <span>Hurry, offer valid till {formattedDateTime}!</span>;
    };
    const getUserNameByGID = async () => {
        setLoader(true);
        if (inputCouponCode.length > 0 && inputCouponCode !== "R1999") {
            var response = await getUserNameByGId(inputCouponCode, true);
            if (response.success) {
                SetAddNewSponsorGrowniverseId(response.data.userName);
                setCouponCode(true);
                setShowCouponCode(false);

                setLoader(false);
                confetti({
                    particleCount: 150,
                    spread: 80,
                    origin: { y: 0.6 },
                    colors: ['#00BCD4', '#8BC34A', '#FFC107', '#FF5722'], // Custom theme colors
                    shapes: ['square', 'circle'], // Try ‘star’ with custom images!
                });
                setInvalidCouponCode(false);
            }
            else {
                SetAddNewSponsorGrowniverseId("");
                setCouponCode(false);
                setInvalidCouponCode(true);
            }
        }
        else {
            SetAddNewSponsorGrowniverseId("");
            setCouponCode(false);
            setInvalidCouponCode(true);
        }
        setLoader(false);
    }
    const onCouponCodeChange = (event: any) => {
        setInvalidCouponCode(false);
        setInputCouponCode(event.target.value);
    }

    const [coursesList, setCoursesList] = useState<any[]>([]);
    const [checkCountCourseList, setCheckoutCoursesList] = useState<any[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const take = 100;
    const listloader = useRef<HTMLDivElement>(null);
    const skip = useRef(0);
    const loadCourses = async () => {
        if (!hasMore) return;
        
        const response = await GetCourseList({
            "skip": skip.current,
            take
        })

        // setCoursesList(prev => [...prev, ...response.data.courses.courseList]);
        setCoursesList(response.data.courses.courseList);
        if (skip.current + take >= response.data.courses.totalRecords) {
            setHasMore(false);
        }
        skip.current = skip.current + take;
    };

    const discountCourses = (coursePrice: number, discount : number) => {
        const discounted = coursePrice - (coursePrice * (discount / 100));

        // Round to nearest integer
        return Math.round(discounted);
    };

    const runOnceForLoad = useRef(false);

    useEffect(() => {
        if (runOnceForLoad.current === true) return;
        loadCourses();
        runOnceForLoad.current = true;
    }, [])

    const UpdateRecord = () => {
        setShowPackages(!getShowPackages)
    }


    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         entries => {
    //             if (entries[0].isIntersecting && hasMore) {
    //                 console.log("Observer hit"); // debug
    //                 loadCourses();
    //             }
    //         },
    //         { threshold: 0 } // fire as soon as element enters view
    //     );

    //     const currentLoader = listloader.current;
    //     if (currentLoader) observer.observe(currentLoader);

    //     return () => {
    //         if (currentLoader) observer.unobserve(currentLoader);
    //     };
    // }, [hasMore]);

    const [searchTerm, setSearchTerm] = useState("");

    // Filter courses based on search term
    const filteredCourses = coursesList.filter(course =>
        course.courseName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const [showCart, setShowCart] = useState(false);
    return <>
        <section className="growniverseBackground" style={{ background: "", padding: "20px" }}>
            {
                template === "cart"
                    ?
                    <div
                        style={{
                            position: "fixed",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#fff",          // clean white background
                            borderRadius: "50%",         // circular shape
                            width: "70px",
                            height: "70px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            zIndex: 1000
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                            e.currentTarget.style.background = "#f5f5f5"; // subtle hover background
                            e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.2)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
                        }}
                        onClick={() => setTemplate("package")}
                    >
                        <span
                            style={{
                                color: "#C62828",          // professional red tone
                                fontSize: "40px",
                                fontWeight: "bold",
                                lineHeight: "1"
                            }}
                        >
                            ✕
                        </span>
                    </div>

                    :
                    template !== "payment" &&
                    <div
                        style={{
                            position: "fixed",      // aligned to the right corner
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#090909",   // clean background
                            borderRadius: "50%",  // circular badge
                            width: "70px",
                            height: "70px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            zIndex: 1000
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                            e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.2)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
                        }}
                        onClick={() => setTemplate("cart")}
                    >
                        <CartIcon count={checkCountCourseList.length} />
                    </div>
            }

            <div style={{ textAlign: "right", marginTop: "10px" }}>
                {
                    couponCode ?
                        <>
                            <Alert severity="success" variant="outlined" style={{ background: "white" }}>
                                ✅ Coupon Applied Successfully!
                            </Alert><br />
                            <button
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#ff4d4d";   // red hover
                                    e.currentTarget.style.color = "#fff";
                                    e.currentTarget.style.border = "1px solid #ff4d4d";
                                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(255,77,77,0.4)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#fff";
                                    e.currentTarget.style.color = "#ff4d4d";
                                    e.currentTarget.style.border = "1px solid #ff4d4d";
                                    e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                                }}
                                style={{
                                    borderRadius: "8px",
                                    background: "#fff",
                                    color: "#ff4d4d", // red text for destructive action
                                    padding: "12px 25px",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    border: "1px solid #ff4d4d",
                                    transition: "all 0.3s ease",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                }}
                                onClick={() => {
                                    setCouponCode(false);
                                    SetAddNewSponsorGrowniverseId("");
                                    setInputCouponCode("");
                                }}
                            >
                                ❌ Remove Coupon Code ({addNewSponsorGrowniverseId})
                            </button>
                        </>
                        :
                        <>
                            <button
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "green";
                                    e.currentTarget.style.color = "#fff";
                                    e.currentTarget.style.border = "1px solid black";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#fff";
                                    e.currentTarget.style.color = "black";
                                    e.currentTarget.style.border = "1px solid black";
                                }}
                                style={{
                                    borderRadius: "8px",
                                    background: "#fff",
                                    color: "black",
                                    padding: "12px 25px",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    border: "1px solid #Daa425",
                                    transition: "all 0.3s ease",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                }}
                                onClick={() => {
                                    setShowCouponCode(!showCouponCode)
                                }}
                            >
                                Coupon Code
                            </button>
                        </>
                }
            </div>
            {
                showCouponCode &&
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.4)", // semi‑transparent dark overlay
                        backdropFilter: "blur(5px)",   // blur background
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,                  // ensure it’s on top
                    }}

                >
                    {loader ? <UserLoaderBlankBackground /> :
                        <div
                            style={{
                                background: "white",
                                width: "80%",
                                height: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                borderRadius: "16px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                                padding: "30px",
                                textAlign: "center",
                            }}
                        >
                            {/* Title */}
                            <h2 style={{ marginBottom: "20px", color: "#343434" }}>Apply Coupon Code</h2>

                            {/* Input */}
                            {
                                couponCode ?
                                    <>
                                        <Alert severity="success" variant="outlined">
                                            ✅ Coupon Applied Successfully!
                                        </Alert><br />
                                    </> :
                                    <input
                                        type="text"
                                        placeholder="Enter Coupon Code"
                                        style={{
                                            padding: "12px",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc",
                                            width: "70%",
                                            fontSize: "16px",
                                            marginBottom: "20px",
                                            outline: "none",
                                            transition: "border 0.3s ease",
                                        }}
                                        onFocus={(e) => (e.currentTarget.style.border = "1px solid #Daa425")}
                                        onBlur={(e) => (e.currentTarget.style.border = "1px solid #ccc")}
                                        onChange={onCouponCodeChange}
                                    />
                            }

                            {
                                invalidCouponCode &&
                                <>
                                    <Alert severity="error" variant="outlined" style={{ background: "white" }}>
                                        Invalid Coupon Code
                                    </Alert><br />
                                </>
                            }

                            {/* Buttons */}
                            <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
                                {/* Apply Button */}
                                {
                                    couponCode ?
                                        <button
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = "#ff4d4d";   // red hover
                                                e.currentTarget.style.color = "#fff";
                                                e.currentTarget.style.border = "1px solid #ff4d4d";
                                                e.currentTarget.style.boxShadow = "0 4px 10px rgba(255,77,77,0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = "#fff";
                                                e.currentTarget.style.color = "#ff4d4d";
                                                e.currentTarget.style.border = "1px solid #ff4d4d";
                                                e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                                            }}
                                            style={{
                                                borderRadius: "8px",
                                                background: "#fff",
                                                color: "#ff4d4d", // red text for destructive action
                                                padding: "12px 25px",
                                                fontSize: "16px",
                                                fontWeight: 600,
                                                cursor: "pointer",
                                                border: "1px solid #ff4d4d",
                                                transition: "all 0.3s ease",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                            }}
                                            onClick={() => {
                                                setCouponCode(false);
                                                SetAddNewSponsorGrowniverseId("");
                                                setInputCouponCode("");
                                            }}
                                        >
                                            ❌ Remove Coupon Code
                                        </button> :
                                        <button
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = "#Daa425";
                                                e.currentTarget.style.color = "#343434";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = "#343434";
                                                e.currentTarget.style.color = "#Daa425";
                                            }}
                                            style={{
                                                borderRadius: "8px",
                                                background: "#343434",
                                                color: "#Daa425",
                                                padding: "12px 25px",
                                                fontSize: "16px",
                                                fontWeight: 600,
                                                cursor: "pointer",
                                                border: "none",
                                                transition: "all 0.3s ease",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                            }}
                                            onClick={getUserNameByGID}
                                        >
                                            Apply
                                        </button>
                                }

                                {/* Close Button */}
                                <button
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = "#Daa425";
                                        e.currentTarget.style.color = "#fff";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = "#fff";
                                        e.currentTarget.style.color = "#Daa425";
                                    }}
                                    style={{
                                        borderRadius: "8px",
                                        background: "#fff",
                                        color: "#Daa425",
                                        padding: "12px 25px",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        border: "1px solid #Daa425",
                                        transition: "all 0.3s ease",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    }}
                                    onClick={() => { setShowCouponCode(false) }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>}
                </div>
            }
        </section>
        {
            template === "cart" ?
                <>
                    <CartModal
                        items={checkCountCourseList}
                        isDiscount={couponCode}
                        AddNewSponsorGrowniverseId={addNewSponsorGrowniverseId}
                    />
                </>
                : <></>
        }
        {
            template === "package" ?
                <>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "20px"
                        }}
                    >
                        <button
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = "green";
                                e.currentTarget.style.color = "#fff";
                                e.currentTarget.style.border = "1px solid black";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = "#fff";
                                e.currentTarget.style.color = "black";
                                e.currentTarget.style.border = "1px solid black";
                            }}
                            style={{
                                width: "50%",
                                borderRadius: "30px",
                                background: "#cdcbcbf6",
                                color: "black",
                                padding: "12px 25px",
                                fontSize: "16px",
                                fontWeight: 600,
                                cursor: "pointer",
                                border: "1px solid #Daa425",
                                transition: "all 0.3s ease",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                            }}
                            onClick={() => {
                                UpdateRecord();
                            }}
                        >
                            {getShowPackages ? "Courses" : "Packages"}
                        </button>
                    </div>

                    {
                        getShowPackages ?
                            <section style={{ background: "#000000f6", padding: "20px" }}>
                                {/* Coupon Code Section */}
                                <div className="container" style={{ justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                                    <div className="row">
                                        {packages.map((pack) =>
                                            <div className="col-md-4 col-sm-6 headerBackground" style={{ borderRadius: "20px", padding: "10px" }}>
                                                <div className="mb-md-0" style={{ height: "auto" }}>
                                                    <img className="img-fluid" src={packagePoster.find(data => data.packageId === pack.packageId)?.poster} alt={packagePoster.find(data => data.packageId === pack.packageId)?.poster} style={{ width: "100%", height: "auto", borderRadius: "20px" }} />
                                                </div><br />
                                                <div style={{ color: "black", background: "#899ba1", width: "100%", display: "inline-grid", borderRadius: "50px" }}>
                                                    <h2 style={{ color: "#Daa425", textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF" }}>
                                                        {pack.packageName}
                                                    </h2>
                                                </div><br /><br />
                                                <div style={
                                                    couponCode ? { color: "black", background: "#919191", width: "100%", height: "230px", borderRadius: "20px" }
                                                        : { alignContent: "space-between", color: "black", background: "#919191", width: "100%", height: "120px", borderRadius: "20px" }
                                                }>

                                                    {/* Show MRP + Discount if sponsorId is R1999 or empty */}
                                                    {/* Case 1: Sponsor is R1999 or empty → show discounted price + MRP */}
                                                    {!couponCode && (
                                                        <>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    background: "#1c1c1c",
                                                                    borderRadius: "12px",
                                                                    color: "white",
                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                                                                }}
                                                            >
                                                                <div style={{ textAlign: "center" }}>
                                                                    {/* Discounted Price (big) */}
                                                                    <div style={{ fontSize: "28px", fontWeight: "700", color: "#00ff7f" }}>
                                                                        ₹{pack.discountedPrice}
                                                                    </div>

                                                                    {/* MRP (small, cut) */}
                                                                    <div style={{ fontSize: "14px", textDecoration: "line-through", opacity: 0.6 }}>
                                                                        MRP: ₹{pack.packagePrice}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {
                                                        couponCode && (
                                                            <div
                                                                style={{
                                                                    background: "linear-gradient(135deg, #786cec, #e9ecef)",
                                                                    borderRadius: "10px",
                                                                    padding: "12px 20px",
                                                                    marginTop: "10px",
                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                                    overflow: "hidden", // keeps text inside
                                                                    position: "relative",
                                                                    height: "50px", // fixed height for smooth scroll
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "inline-block",
                                                                        whiteSpace: "nowrap",
                                                                        animation: "marquee 10s linear infinite",
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            fontWeight: "600",
                                                                            marginRight: "50px", // spacing between repeats
                                                                            background: "linear-gradient(to right, #2c3e50, #4a90e2)",
                                                                            WebkitBackgroundClip: "text",
                                                                            WebkitTextFillColor: "transparent",
                                                                        }}
                                                                    >
                                                                        Discount 30%
                                                                    </span>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            fontWeight: "600",
                                                                            marginRight: "50px",
                                                                            background: "linear-gradient(to right, #2c3e50, #4a90e2)",
                                                                            WebkitBackgroundClip: "text",
                                                                            WebkitTextFillColor: "transparent",
                                                                        }}
                                                                    >
                                                                        Discount 30%
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    {/* Case 2: Sponsor is different → show Limited Time Deal + cut Discount + MRP */}
                                                    {(couponCode) && (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                background: "#0c0c14f6",
                                                                padding: "15px 20px",
                                                                borderRadius: "12px",
                                                                margin: "10px 0",
                                                                color: "white",
                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                                                            }}
                                                        >
                                                            <div style={{ textAlign: "center" }}>
                                                                {/* Limited Time Deal (big) */}
                                                                <div style={{ fontSize: "20px", fontWeight: "700", color: "#00ff7f" }}>
                                                                    LIMITED TIME DEAL: ₹{discountCourses(pack.discountedPrice, discountOnPackage)}
                                                                </div>

                                                                {/* Discount (cut) */}
                                                                <div style={{ fontSize: "14px", textDecoration: "line-through", color: "#ff4d4d" }}>
                                                                    Discount: ₹{pack.discountedPrice}
                                                                </div>

                                                                {/* MRP (cut) */}
                                                                <div style={{ fontSize: "14px", textDecoration: "line-through", opacity: 0.6 }}>
                                                                    MRP: ₹{pack.packagePrice}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div style={{ marginTop: "10px" }}>
                                                        <button style={{ borderRadius: "30px", background: "#0c0c14f6", padding: "10px" }} onClick={() => packageDetails(pack)}>
                                                            <b style={{ color: "#Daa425", fontSize: "20px" }}>EXPLORE MORE</b>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </section>
                            :
                            <section style={{ background: "#000000f6", padding: "20px" }}>
                                <div className="container" style={{ textAlign: "center" }}>
                                    <input
                                        type="text"
                                        placeholder="Search courses..."
                                        value={searchTerm}
                                        onChange={e => setSearchTerm(e.target.value)}
                                        className="form-control mb-3"
                                        style={{ fontWeight: "bold" }}
                                    />
                                    <div className="row">
                                        {filteredCourses.map(course => (
                                            <div
                                                key={course.CourseId}
                                                className="col-md-4 col-sm-6 headerBackground"
                                                style={{ borderRadius: "20px", padding: "10px" }}
                                            >
                                                <div>
                                                    <img className="img-fluid posterShow" src={courseImage.find(data => data.courseId === course.courseId)?.posterLink} alt={course.images} />
                                                </div><br />
                                                <div style={{ background: "#afe4e9", borderRadius: "20px", padding: "10px" }}>
                                                    <h2 style={{ color: "#0b0b0b" }}>
                                                        {course.courseName}
                                                    </h2>
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: "15px",
                                                        background: "#eceaea",
                                                        borderRadius: "20px",
                                                        padding: "15px",
                                                        minHeight: "200px",
                                                        color: "black"
                                                    }}
                                                >

                                                    <p><b>Description:</b> {course.courseDescription}</p>
                                                    {
                                                        !couponCode && (
                                                            <div
                                                                style={{
                                                                    background: "linear-gradient(135deg, #786cec, #e9ecef)",
                                                                    borderRadius: "10px",
                                                                    padding: "12px 20px",
                                                                    marginTop: "10px",
                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                <p style={{ fontSize: "18px", fontWeight: "600", color: "#007bff", margin: 0 }}>
                                                                    ₹{course.coursePrice}
                                                                </p>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        couponCode && (
                                                            <div
                                                                style={{
                                                                    background: "linear-gradient(135deg, #786cec, #e9ecef)",
                                                                    borderRadius: "10px",
                                                                    padding: "12px 20px",
                                                                    marginTop: "10px",
                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                                    overflow: "hidden", // keeps text inside
                                                                    position: "relative",
                                                                    height: "50px", // fixed height for smooth scroll
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "inline-block",
                                                                        whiteSpace: "nowrap",
                                                                        animation: "marquee 10s linear infinite",
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            fontWeight: "600",
                                                                            marginRight: "50px", // spacing between repeats
                                                                            background: "linear-gradient(to right, #2c3e50, #4a90e2)",
                                                                            WebkitBackgroundClip: "text",
                                                                            WebkitTextFillColor: "transparent",
                                                                        }}
                                                                    >
                                                                        Discount 10%
                                                                    </span>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            fontWeight: "600",
                                                                            marginRight: "50px",
                                                                            background: "linear-gradient(to right, #2c3e50, #4a90e2)",
                                                                            WebkitBackgroundClip: "text",
                                                                            WebkitTextFillColor: "transparent",
                                                                        }}
                                                                    >
                                                                        Discount 10%
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                    {(couponCode) && (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                background: "#0c0c14f6",
                                                                padding: "15px 20px",
                                                                borderRadius: "12px",
                                                                margin: "10px 0",
                                                                color: "white",
                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                                                            }}
                                                        >
                                                            <div style={{ textAlign: "center" }}>
                                                                {/* Limited Time Deal (big) */}
                                                                <div style={{ fontSize: "20px", fontWeight: "700", color: "#00ff7f" }}>
                                                                    LIMITED TIME DEAL: ₹{discountCourses(course.coursePrice,discountOnPackage)}
                                                                </div>

                                                                {/* Discount (cut) */}
                                                                <div style={{ fontSize: "14px", textDecoration: "line-through", color: "#ff4d4d" }}>
                                                                    Discount: ₹{course.coursePrice}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {
                                                        checkCountCourseList.find(data => data.courseId === course.courseId) ? (
                                                            <button
                                                                style={{
                                                                    borderRadius: "25px",
                                                                    background: "#C62828", // professional red tone
                                                                    padding: "12px 28px",
                                                                    marginTop: "12px",
                                                                    border: "none",
                                                                    color: "#fff",
                                                                    fontSize: "16px",
                                                                    fontWeight: 600,
                                                                    cursor: "pointer",
                                                                    transition: "all 0.3s ease",
                                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)"
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.background = "#B71C1C"; // darker red on hover
                                                                    e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.2)";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.background = "#C62828";
                                                                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.15)";
                                                                }}
                                                                onClick={() => {
                                                                    setCheckoutCoursesList(prev =>
                                                                        prev.filter(item => item.courseId !== course.courseId)
                                                                    );
                                                                }}
                                                            >
                                                                <b style={{ fontSize: "18px" }}>Remove From Cart</b>
                                                            </button>
                                                        ) : (
                                                            <button
                                                                style={{
                                                                    borderRadius: "25px",
                                                                    background: "#1E88E5", // professional blue tone
                                                                    padding: "12px 28px",
                                                                    marginTop: "12px",
                                                                    border: "none",
                                                                    color: "#fff",
                                                                    fontSize: "16px",
                                                                    fontWeight: 600,
                                                                    cursor: "pointer",
                                                                    transition: "all 0.3s ease",
                                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)"
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.background = "#1565C0"; // darker blue on hover
                                                                    e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.2)";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.background = "#1E88E5";
                                                                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.15)";
                                                                }}
                                                                onClick={() => {
                                                                    setCheckoutCoursesList(prev => [...prev, course]);
                                                                }}
                                                            >
                                                                <b style={{ fontSize: "18px" }}>Add To Cart</b>
                                                            </button>

                                                        )
                                                    }


                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {hasMore && (
                                        <div
                                            ref={listloader}
                                            style={{
                                                height: "80px",
                                                marginTop: "20px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                background: "transparent"
                                            }}
                                        >
                                            <ClipLoader color="#36d7b7" size={50} />
                                        </div>
                                    )}
                                </div>
                            </section>
                    }
                </>

                :
                <>
                    {
                        template === "packageDetail" ?
                            <>
                                <div className='container' style={{ padding: "10px" }}>
                                    <div style={{ padding: "10px" }}>
                                        <Button onClick={() => { (setTemplate("package")) }} style={{ borderRadius: "20px", color: "white", background: "#343434" }}><i className="fa-solid fa-arrow-left"></i></Button>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-7 col-xl-8'>
                                            <img className="img-fluid" src={packagePoster.find(data => data.packageId === packageDetailData.packageId)?.poster} alt={packagePoster.find(data => data.packageId === packageDetailData.packageId)?.poster} style={{ width: "100%", height: "400px", borderRadius: "20px" }} />
                                            <h4 className="news-title mb-2">{packageDetailData.packageName}</h4>
                                            <div className=''>
                                                <div className='widgets'>
                                                    <div className="widget widget-price">
                                                        <div className="widget-content" style={{ padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
                                                            {!couponCode && (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        background: "#000000f6",
                                                                        padding: "15px 20px",
                                                                        borderRadius: "12px",
                                                                        margin: "10px 0",
                                                                        color: "white",
                                                                        boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                                                                    }}
                                                                >
                                                                    <div style={{ textAlign: "center" }}>
                                                                        {/* Discounted Price (big) */}
                                                                        <div style={{ fontSize: "28px", fontWeight: "700", color: "#00ff7f" }}>
                                                                            ₹{packageDetailData.discountedPrice}
                                                                        </div>

                                                                        {/* MRP (small, cut) */}
                                                                        <div style={{ fontSize: "14px", textDecoration: "line-through", opacity: 0.6 }}>
                                                                            MRP: ₹{packageDetailData.packagePrice}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {
                                                                couponCode && (
                                                                    <div
                                                                        style={{
                                                                            background: "linear-gradient(135deg, #786cec, #e9ecef)",
                                                                            borderRadius: "10px",
                                                                            padding: "12px 20px",
                                                                            marginTop: "10px",
                                                                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                                            overflow: "hidden", // keeps text inside
                                                                            position: "relative",
                                                                            height: "50px", // fixed height for smooth scroll
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                display: "inline-block",
                                                                                whiteSpace: "nowrap",
                                                                                animation: "marquee 10s linear infinite",
                                                                            }}
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "18px",
                                                                                    fontWeight: "600",
                                                                                    marginRight: "50px", // spacing between repeats
                                                                                    background: "linear-gradient(to right, #2c3e50, #4a90e2)",
                                                                                    WebkitBackgroundClip: "text",
                                                                                    WebkitTextFillColor: "transparent",
                                                                                }}
                                                                            >
                                                                                Discount 30%
                                                                            </span>
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "18px",
                                                                                    fontWeight: "600",
                                                                                    marginRight: "50px",
                                                                                    background: "linear-gradient(to right, #2c3e50, #4a90e2)",
                                                                                    WebkitBackgroundClip: "text",
                                                                                    WebkitTextFillColor: "transparent",
                                                                                }}
                                                                            >
                                                                                Discount 30%
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            {/* Case 2: Sponsor is different → show Limited Time Deal + cut Discount + MRP */}
                                                            {(couponCode) && (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        background: "#000000f6",
                                                                        padding: "15px 20px",
                                                                        borderRadius: "12px",
                                                                        margin: "10px 0",
                                                                        color: "white",
                                                                        boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                                                                    }}
                                                                >
                                                                    <div style={{ textAlign: "center" }}>
                                                                        {/* Limited Time Deal (big) */}
                                                                        <div style={{ fontSize: "20px", fontWeight: "700", color: "#00ff7f" }}>
                                                                            LIMITED TIME DEAL: ₹{discountCourses(packageDetailData.discountedPrice,discountOnPackage)}
                                                                        </div>

                                                                        {/* Discount (cut) */}
                                                                        <div style={{ fontSize: "14px", textDecoration: "line-through", color: "#ff4d4d" }}>
                                                                            Discount: ₹{packageDetailData.discountedPrice}
                                                                        </div>

                                                                        {/* MRP (cut) */}
                                                                        <div style={{ fontSize: "14px", textDecoration: "line-through", opacity: 0.6 }}>
                                                                            MRP: ₹{packageDetailData.packagePrice}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                                <Button
                                                                    onClick={() => { setTemplate("payment") }}
                                                                    style={{
                                                                        borderRadius: "25px",
                                                                        backgroundColor: "#007bff",
                                                                        color: "white",
                                                                        padding: "15px",
                                                                        fontWeight: "bold",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                    className="btn btn-primary"
                                                                >
                                                                    <span style={{ fontSize: "18px", fontWeight: "bold", marginRight: "10px" }}>Get {packageDetailData.packageName}</span>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div><br />
                                            <div className="border mb-4">
                                                <div className="p-4 border-top">
                                                    <CourseInfoWidget packageId={packageDetailData.packageId} />
                                                </div>
                                            </div>
                                            <div className=''>
                                                <div className='widgets'>
                                                    <SocialShareWidget />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </> :
                            <>
                                {
                                    template === "payment" ?
                                        <>
                                            <section style={{ background: "#343434" }}>
                                                <div style={{ padding: "10px" }}>
                                                    <Button onClick={() => { (setTemplate("packageDetail")) }} style={{ borderRadius: "20px", color: "#343434", background: "white" }}><i className="fa-solid fa-arrow-left"></i></Button>
                                                </div>
                                                <Payment
                                                packageId={packageDetailData.packageId}
                                                packageName={packageDetailData.packageName}
                                                price={couponCode ? discountCourses(packageDetailData.discountedPrice,discountOnPackage) : packageDetailData.discountedPrice}
                                                IsUpgrade={false} CouponCode={couponCode} AddNewSponsorGrowniverseId={addNewSponsorGrowniverseId} />
                                            </section>
                                        </>
                                        : <></>
                                }
                            </>
                    }
                </>
        }
    </>
};

export default Package; 